import React, { useEffect, useState } from 'react'
import { View, TextInput, TouchableOpacity } from 'react-native'
import { inputTextPlaceholder } from '../../../../theme/colors'
import { styles } from './styles'
import { MicIcon, SearchIcon } from '../../../Svg'

interface Props {
  placeholder: string
  initValue: string
  startSpeechToText: () => Promise<void>
  getValue: (value: string) => void
}
export const SearchInput = ({ placeholder, startSpeechToText, getValue, initValue }: Props) => {
  const [value, setValue] = useState(initValue)

  const onChange = (value: string) => setValue(value)

  useEffect(() => {
    if (getValue) getValue(value)
  }, [value])

  useEffect(() => {
    onChange(initValue)
  }, [initValue])

  return (
    <View style={styles.container}>
      <View style={{ flex: 1 }}>
        <TextInput
          style={styles.input}
          placeholderTextColor={inputTextPlaceholder}
          onChangeText={onChange}
          value={value}
          placeholder={placeholder}
        />
        <SearchIcon height={20} width={20} style={styles.searchIcon} />
      </View>

      <TouchableOpacity onPress={startSpeechToText}>
        <MicIcon height={20} width={20} />
      </TouchableOpacity>
    </View>
  )
}
